<!-- 
	uses layout "./layouts/Dashboard.vue" .
 -->

<template>
	<div class="mt-5">
		<!-- Header  -->
		<div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
				
		<a-row type="flex" :gutter="24" style="margin-top: -170px;">

			
			<a-col :span="24" :md="10" :sm="22" :lg="12" offset="1"  class="mb-24">
				<height-watcher>
					<div
						class="budgets-page-body"
						slot-scope="{ height, offset }"
						:offset="offset"
						:style="{
							'max-height': height - (250) + 'px',
							height: height - (250) + 'px',
						}"
					>
						<!-- Appointment List Card -->
						<review-appointment-list ref="reviewList"/>
					</div>
				</height-watcher>	
			</a-col>
			
			<a-col :span="24" :md="12" :sm="10" :lg="10" class="mb-24 c_appointment_timeline" >
				<height-watcher>
					<div
						class="budgets-page-body"
						slot-scope="{ height, offset }"
						:offset="offset"
						:style="{
							'max-height': height - (250) + 'px',
							height: height - (250) + 'px',
						}"
					>
						<!-- Existing appointments -->
						<appointment-timeline 
							@approved="(e) => $refs.reviewList.approved(e)" 
							@rescheduled="(e) => $refs.reviewList.rescheduled(e)" 
						/>
						
					</div>
				</height-watcher>
			</a-col>
		</a-row>
	</div>
</template>

<script>
import ReviewAppointmentList from "./appointments/review/ReviewAppointmentList.vue";
import AppointmentTimeline from "./appointments/AppointmentTimeline.vue";
import HeightWatcher from "../components/height-watcher/HeightWatcher.vue";

export default ({
    components: {
        ReviewAppointmentList,
        AppointmentTimeline,
		HeightWatcher,
    },
    data() {
        return {
        }
    },
})

</script>

<style lang="scss">
// @media screen and (min-width: 768px) {
// 	.c_appointment_timeline{
// 		display: block;
// 	}
// }
@media screen and (max-width: 767px) {
	.c_appointment_timeline{
		display: none;
	}
}
</style>